module.exports = __webpack_public_path__ + "static/media/workPvcCeilings15.3112111b.jpg";